import React from "react";

import "./index.css";

import DecoMethodsTableContainer from "./DecoMethodsTableContainer";
import { DecoMethodsContextProvider } from "../../../../contexts/deco-methods.context";

function DecoMethods(props) {
  return (
    <div className="deco-container">
      <DecoMethodsTableContainer />
    </div>
  );
}

export default DecoMethods;
